import React from 'react';
import moment from 'moment';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import * as IconFont from '../../constants/icons';

import BookingBoxComponent from '../../components/BookingBox/BookingBoxComponent';
import InfoBoxComponent from '../../components/InfoBox/InfoBoxComponent';
import { isValidMemberType } from '../../constants/levels';
import Icon from '@ant-design/icons';
import Loader from '../../components/common/Loader';


const dayTo = (booking) => {
  return moment(new Date(booking.checkInDate)).diff(moment(), 'days');
};

const EnrichBooking = ({ loy3User, hotelId, context }) => {
  const isValidLoyaltyType = isValidMemberType(loy3User.memberShipName);
  const extraProps = isValidLoyaltyType ? {
    icon: 'crown',
    hoverable: true,
    link: `/catalogue/${hotelId}`,
  } : { disabled: true };
  return (
    <InfoBoxComponent
      mode="inline"
      title={context.t('enrich your stay')}
      body={context.t('With our best quality products')}
      {...extraProps}
    />
  );
};

const UpcomingBooking = ({ loy3User, booking, context }) => {
  const showEnrich = !!loy3User;
  return (
    <Row gutter={24} type="flex">
      <Col md={18} sm={24} xs={24}>
        <BookingBoxComponent
          booking={booking}
          head={context.t('Upcoming booking') + ' - '}
          alert={{
            name: context.t(['Your trip is coming in {days} day', 'Your trip is coming in {days} days', 'days'], { days: dayTo(booking) }),
            colorClass: 'text-status-danger',
          }}
          action={{
            phone: booking.hotelPhone,
            email: booking.hotelEmail,
            address: booking.hotelAddress,
          }}
        />
      </Col>
      {showEnrich && (
        <Col md={6} sm={24} xs={24} className="elem-stretch d-sm-block">
          <EnrichBooking loy3User={loy3User} hotelId={booking.hotelId} context={context} />
        </Col>
      )}
    </Row>
  );
};

const PastBooking = ({ booking, context}) => (
  <Row gutter={24} type="flex">
    <Col md={24} sm={24} xs={24}>
      <BookingBoxComponent
        mode="last"
        head={context.t('latest stay')}
        booking={booking}
      />
    </Col>
  </Row>
);

const DashboardBookings = ({ isLoading, loy3User, past, upcoming, context }) => {
  if (isLoading) {
    return (
      <Loader fullScreen>
        {context.t('Loading your bookings, it will take a few seconds...')}
      </Loader>
    );
  }

  const showBookingsLink = upcoming || past;
  return (
    <div className="dashboard-bookings">
      {upcoming && <UpcomingBooking loy3User={loy3User} booking={upcoming} context={context} />}
      {past && <PastBooking booking={past} context={context} /> }
      {showBookingsLink && (
        <div className="ml-6 pb-12">
          <Link to="/bookings">
            <Icon component={IconFont.SEE} /> {context.t('see all bookings')}
          </Link>
        </div>
      )}
    </div>
  );
};

export default DashboardBookings;
